import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import { SecondaryStyle } from "../fonts";
import SwipeableTextMobileStepper from "./MobileStepper";

import RBT from "../assets/Page5RBT.webp";
import LA from "../assets/Page5LA.webp";
import LC from "../assets/Page5LC.webp";

import Carousel1Image1 from "../assets/Page5RA1.webp";
import Carousel1Image2 from "../assets/Page5RA2.webp";

//@ts-ignore
import RBB from "../assets/Page5RBB.mp4";
//@ts-ignore
import LB from "../assets/Page5LB.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2];

const Page5 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{
                height: "100%",
                borderTop: { xs: "1vh solid #fff", sm: "none" },
              }}
            >
              {/* LA/LD */}

              {/* LC */}
              <Grid
                item
                xs={12}
                sx={{
                  borderRadius: { xs: "16px", sm: "0vh" },
                  maxHeight: "50vh",
                  borderBottom: ".5vh solid #fff",
                  height: {
                    xs: "46vh",
                    sm: "100%",
                  },
                  borderRight: {
                    xs: "1vh solid #fff",
                    sm: ".5vh solid #fff",
                  },
                  borderLeft: {
                    xs: "1vh solid #fff",
                    sm: "none",
                  },
                  backgroundImage: `url('${LA}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />

              {/** */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderTop: ".5vh solid #fff",
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      height: {
                        xs: "46vh",
                        sm: "100%",
                      },
                      backgroundImage: `url('${LC}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  />
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: { xs: "46vh", sm: "100%" },
                      maxHeight: "50vh",
                      borderBottom: { xs: ".5vh solid #fff", sm: "none" },
                      borderTop: ".5vh solid #fff",

                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "bottom",
                      }}
                      src={LB}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    maxHeight: { xs: "82vh", sm: "100%" },
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },
                  }}
                >
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      height: {
                        xs: "35.5vh",
                        sm: "50vh",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel1Images} />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderTop: ".5vh solid #fff",
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.5vw",
                            md: "1.5vw",
                            lg: "1.5vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      This expansive 341-square-foot attic offers a unique,
                      loft-like retreat within the home. With its exposed brick
                      walls, natural light, and architectural charm, it’s a
                      versatile space that can serve as a cozy guest room, home
                      office, or family room. The open layout invites
                      creativity, allowing you to shape it to fit your
                      lifestyle—whether it’s a peaceful spot to work, a place to
                      relax with a book, or a flexible area for family needs.
                      With its blend of character and functionality, this attic
                      is the perfect private escape.
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      height: {
                        xs: "94vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "46vh", sm: "24vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        backgroundImage: `url('${RBT}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />

                    <Box
                      sx={{
                        height: { xs: "46vh", sm: "25vh" },

                        borderTop: ".5vh solid #fff",
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "bottom",
                        }}
                        src={RBB}
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page5;
